/* eslint-disable no-console */
/* eslint-disable max-len */
import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { collection } from './../../services/collection';
import { scrollToElement } from '@/utils/scroll';
import { CollectionLoadMore } from './CollectionLoadMore';

@Component
export class CollectionMain extends ThemeComponent {
    @Ref() loading!: HTMLElement;
    @Ref productGrid!: HTMLElement;
    @Ref({ required: false }) productCountLabel!: HTMLElement; // Add a reference for the product count label
    @Ref({ required: false }) collectionLoadMore!: CollectionLoadMore[];
    @Ref({ required: false }) loadingBar!: HTMLElement;

    @Prop pageZeroProductCount!: number;
    @Prop total!: string;
    @Prop totalPages!: string;
    @Prop collectionName!: string;

    private currentPage = 1;
    private totalPagesNumber = 0;

    init() {
        // Subscribe to collection state changes
        this.$subscribe(collection.onChange, async() => {
            await this.reload();
            this.findNewLoadMoreComponents();
        });

        // Subscribe to load more loading
        this.subscribeToLoadMoreLoading();
        this.setupCardListeners();

        // Scroll to element
        this.collectionScroll();
    }

    async reload() {
        // Set loading
        this.setLoading(true);

        // Make request for the next URL
        const response = await collection.render(['collection-main']);

        // Create a div containing new collection main section markup
        const newCollectionMainSection = document.createElement('div');
        newCollectionMainSection.innerHTML = response['collection-main'];

        // Prepare correct markup - CollectionMain
        const newCollectionMainContainer = newCollectionMainSection.querySelector('.product-grid__products');
        const currentCollectionMainContainer = this.querySelector('.product-grid__products');
        if (newCollectionMainContainer && currentCollectionMainContainer) {
            currentCollectionMainContainer.outerHTML = newCollectionMainContainer.outerHTML;
        }

        // Set loading
        this.setLoading(false);
    }

    public setLoading(loadingState: boolean = false) {
        this.loading.classList.toggle('loading-spinner--active', loadingState);
    }

    private subscribeToLoadMoreLoading() {
        const loadMoreElements = this.querySelectorAll('[data-ref="collectionLoadMore"]');

        for (const loadMore of loadMoreElements) {
            const testElem = loadMore as CollectionLoadMore;
            this.$subscribe(testElem.onLoading, (loading) => {
                this.setLoading(loading);
                this.setupCardListeners();
            });
            loadMore.setAttribute('data-has-loading-listener', 'true');
        }
    }

    private findNewLoadMoreComponents() {
        const loadMoreElements = this.querySelectorAll('[data-ref="collectionLoadMore"]');
        for (const loadMoreElement of loadMoreElements) {
            if (!loadMoreElement.hasAttribute('data-has-loading-listener')) {
                const loadMoreComponent = loadMoreElement as CollectionLoadMore;
                this.$subscribe(loadMoreComponent.onLoading, (loading) => {
                    this.setLoading(loading);
                });
                loadMoreElement.setAttribute('data-has-loading-listener', 'true');
            }
        }
    }

    private setupCardListeners() {
        //attach product card listeners for returning scroll to product
        const productCards = this.productGrid.querySelectorAll('.product-grid__product-item') as NodeListOf<HTMLElement>;

        for (const card of productCards) {
            this.$listen(card, 'click', (e) => {
                const cardId = String(card.dataset.cardId);
                const collectionName = this.collectionName;
                e.stopImmediatePropagation();
                sessionStorage.setItem("product_card_value", cardId);
                sessionStorage.setItem("collection_name", collectionName);
            });
        }
    }

    private collectionScroll() {
        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        }

        const storedCollectionName = sessionStorage.getItem("collection_name");
        const storedProductId = sessionStorage.getItem("product_card_value");
        const productQueryString = "[data-card-id=\"" + storedProductId + "\"]";

        // check if current collection matches stored collection
        if (storedCollectionName == this.collectionName) {
            const productElement = this.productGrid.querySelector(productQueryString) as HTMLElement;

            if (productElement) {
                scrollToElement(productElement, true);
            }
        } else {
            sessionStorage.removeItem("collection_name");
            sessionStorage.removeItem("product_card_value");
        }
    }
}
